import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getCoinagencyRankInfo = createAsyncThunk(
  'CoinagencyRank/getCoinagencyRankInfo',
  async (e, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/recharge_agency_rank', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
interface itemProp {
  member_info: {
    avatar: string
    id: number
    name: string
    zy_id: string
  }
  rank: number
  score: number
  is_show?: boolean
}
// const initialState: {
//   list: Array<itemProp>
//   activity_expire: number
//   own: itemProp
//   score: number
//   rank_type: number
// } = {
//   list: [],
//   activity_expire: 0,
//   own: {
//     member: {},
//     rank_no: '',
//     score: 0,
//     is_show: false,
//   },
//   score: 0,
//   rank_type: 1, // 1 主播榜， 2，supporter榜
// }
const initialState: {
  list: Array<itemProp>
  count_down: number
  own: itemProp
  activity_time: string
} = {
  own: {
    member_info: {} as any,
    score: 0,
    rank: 0,
  },
  list: [],
  count_down: 0,
  activity_time: '',
}
export const CoinagencyRankSlice = createSlice({
  name: 'CoinagencyRank',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoinagencyRankInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})
export default CoinagencyRankSlice.reducer
